import React, { useEffect } from 'react';
import { Footer, PageBackground, TopBar } from 'src/components';
import ScrollToTopButton from 'src/components/ScrollToTopButton';
import InfoPagesHeader from 'src/layouts/components/InfoPagesHeader';

interface InfoPagesLayoutProps {
  children: React.ReactElement;
  title: string;
}

const InfoPagesLayout: React.FC<InfoPagesLayoutProps> = ({ children, title }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <TopBar />
      <PageBackground hideLines={true}>
        <InfoPagesHeader title={title} />
        {children}
        <Footer />
      </PageBackground>
      <ScrollToTopButton />
    </>
  );
};

export default InfoPagesLayout;
